import React, { useEffect, useRef, useState } from 'react';

const CallsSummary = () => {
  const [subs, setSubs] = useState([]);
  const [currentTime, setCurrentTime] = useState(null);
  const audioRef = useRef(null);

  const test = [
    {
      speaker:
        '[{"start_time": 1420, "speaker": "Speaker 1", "end_time": "00:00:02,323", "text": "Hello.  How are you?  "}, {"start_time": "00:00:03,323", "speaker": "Speaker 0", "end_time": "00:00:05,165", "text": "Hello. How are you?  Good.  "}, {"start_time": "00:00:05,285", "speaker": "Speaker 1", "end_time": "00:00:09,948", "text": "I\'m I\'m an agent with I\'m better. I was inquiring about payment.  "}, {"start_time": "00:00:12,250", "speaker": "Speaker 0", "end_time": "00:00:19,095", "text": "Oh, okay. Can you please let me know your full name?  "}, {"start_time": "00:00:19,115", "speaker": "Speaker 1", "end_time": "00:00:33,325", "text": "My full name is Bennett. Okay.  And your MPM.  And again, it\'s 1-7-5-5-1-4-7-0.  "}, {"start_time": "00:00:36,966", "speaker": "Speaker 0", "end_time": "00:00:58,515", "text": "Okay, let me just one second. Okay.  And you told me that you\'re having an issue with your ambitter payment, right?  Yes.  Okay, this is about the commissions.  "}, {"start_time": "00:01:00,168", "speaker": "Speaker 1", "text": "Yes. "}, {"start_time": "00:01:01,228", "speaker": "Speaker 0", "end_time": "00:01:11,692", "text": "OK, got it. Let me ask you something.  Maybe you get registered into the ADP work market portal?  "}, {"start_time": "00:01:13,873", "speaker": "Speaker 1", "end_time": "00:01:25,337", "text": "I don\'t think I went to ADP because I\'m with Espiro. So I call them.  I call them, and they say they pay New Health Partners.  That\'s their name, right?  "}, {"start_time": "00:01:25,857", "speaker": "Speaker 0", "text": "Yeah. "}, {"start_time": "00:01:27,517", "speaker": "Speaker 1", "text": "OK, then that\'s who they pay. "}, {"start_time": "00:01:30,137", "speaker": "Speaker 0", "end_time": "00:01:55,087", "text": "Yeah, because the system that we are using in this moment to make the commission\'s payment is a system that is called ABP Work Market. So, I would be doing something for you right now, and let me confirm, your email is G-V-E-N-E-T-O-N.  That\'s Benetton.  "}, {"start_time": "00:01:55,347", "speaker": "Speaker 1", "text": "That\'s the number nine, yeah, number nine. "}, {"start_time": "00:01:57,788", "speaker": "Speaker 0", "text": "At gmail.com, right? "}, {"start_time": "00:02:00,000", "speaker": "Speaker 1", "text": "My first name and number 9 are Jimmy.com. "}, {"start_time": "00:02:03,742", "speaker": "Speaker 0", "end_time": "00:02:39,444", "text": "Okay, got it. So, I will be sending you the ADP work market link so you can register under the link and I will send you to a calendar that you will be using to see when you will be receiving your commissions.  So with this in mind, you should know that the commissions that you haven\'t received by today, you will be receiving them on the next payment cycle, okay?  "}, {"start_time": "00:02:40,825", "speaker": "Speaker 1", "end_time": "00:02:42,507", "text": "Yeah, okay. So you want to send me a link?  "}, {"start_time": "00:02:43,888", "speaker": "Speaker 0", "text": "Yep, allow me just one sec and I will be doing it for you right away. "}, {"start_time": "00:02:49,565", "speaker": "Speaker 1", "text": "OK. "}, {"start_time": "00:02:57,927", "speaker": "Speaker 0", "end_time": "00:04:29,267", "text": "OK. you Okay, now I have sent you the email.  This email comes from simon at newhelppartner.com.  Sometimes it takes a while but just wait until it gets to your email and let me know when you have the email.  "}, {"start_time": "00:04:29,928", "speaker": "Speaker 1", "text": "I have sent the email. "}, {"start_time": "00:04:32,129", "speaker": "Speaker 0", "end_time": "00:05:22,524", "text": "Okay, got it. So now you have the link and at the bottom of the message you will see attached the commission payment.  In there, you will be seen when you can receive the commissions.  The next one will be on March 11th.  So you will be receiving the payment by this Friday or next Monday.  But you must... Yeah, you have to create the account under ADP work market and you will be receiving the commission payment as usual by next week.  "}, {"start_time": "00:05:25,127", "speaker": "Speaker 1", "end_time": "00:05:34,115", "text": "I wish I did a lot of business. I didn\'t do too much.  Do you know how much you pay in Georgia per person?  "}, {"start_time": "00:05:36,076", "speaker": "Speaker 0", "text": "Can you repeat it? "}, {"start_time": "00:05:37,177", "speaker": "Speaker 1", "text": "Do you know how much it is per person in Georgia? "}, {"start_time": "00:05:46,980", "speaker": "Speaker 0", "text": "To be honest with you, I cannot see it because I am not in the commission department, but I can talk with the guys from the commissions and they can call you back. "}, {"start_time": "00:05:56,844", "speaker": "Speaker 1", "text": "Okay, please talk to them in the comment box. "}, {"start_time": "00:05:59,585", "speaker": "Speaker 0", "text": "Okay, sir, so if they can help you with. "}, {"start_time": "00:06:03,827", "speaker": "Speaker 1", "end_time": "00:06:31,534", "text": "Yeah, hold on, because I\'m just going to say the industry, which industry would that use? finance?  It\'s a personal information, it\'s the education, digital standard, enterprise software, finance and accounting.  I don\'t see anything relating to insurance.  All right.  I fill out this and send it to them, right?  I signed up as an individual, not as a company.  "}, {"start_time": "00:06:41,287", "speaker": "Speaker 0", "end_time": "00:07:01,101", "text": "When you\'re registered, you must submit it as business instead of individual, and you have to use the tax ID instead of the social security number, and you can receive all the payments. I mean, it\'s the way that this page works.  "}, {"start_time": "00:07:01,921", "speaker": "Speaker 1", "end_time": "00:07:17,874", "text": "I have to use my existing company. It\'s not an insurance company.  Is that okay?  I have an existing business but it\'s not an insurance company.  Is that fine?  "}, {"start_time": "00:07:19,575", "speaker": "Speaker 0", "text": "Yes, that\'s fine. "}, {"start_time": "00:07:23,738", "speaker": "Speaker 1", "text": "So you have to be a company, not an individual. "}, {"start_time": "00:07:27,301", "speaker": "Speaker 0", "text": "Yes, sir. "}, {"start_time": "00:07:31,846", "speaker": "Speaker 1", "end_time": "00:07:33,708", "text": "OK. That\'s what I\'ll do.  "}, {"start_time": "00:07:35,549", "speaker": "Speaker 0", "text": "OK, so I will be getting in touch with the commissions guy so they can call you back, OK? "}, {"start_time": "00:07:41,133", "speaker": "Speaker 1", "end_time": "00:07:49,160", "text": "Yeah, let me ask you a question before you hang up. Even though this company that I have here is not from my previous business, it\'s not related to insurance.  It doesn\'t matter?  "}, {"start_time": "00:07:50,941", "speaker": "Speaker 0", "text": "No, it doesn\'t matter. "}, {"start_time": "00:07:51,742", "speaker": "Speaker 1", "end_time": "00:07:58,827", "text": "It doesn\'t matter. OK.  All right.  Thank you.  "}]',
      summary:
        "- Caller inquires about payment and mentions being with Espiro.\n- Agent asks for full name and MPM.\n- Agent mentions using ADP Work Market portal for commissions payments.\n- Caller confirms not registering with ADP and is paid by New Health Partners.\n- Agent sends email with ADP Work Market link for registration.\n- Next payment cycle for commissions is on March 11th.\n- Caller asks about payment amount per person in Georgia.\n- Agent suggests contacting commissions department for payment information.\n- Caller asks about industry to select for registration.\n- Agent advises selecting business instead of individual for registration.\n- Caller mentions having an existing business not related to insurance.\n- Agent confirms it's fine to use existing business for registration.\n- Caller plans to register as a company instead of an individual.\n- Agent will contact commissions department to call back for further assistance.",
    },
  ];

  // function parseSRT(srtText) {
  //   return srtText.split('\n\n').map((subtitle) => {
  //     const subtitleParts = subtitle.split('\n');
  //     const times = subtitleParts[1].split(' --> ');
  //     const startTime = parseTime(times[0]);
  //     const endTime = parseTime(times[1]);
  //     const text = subtitleParts.slice(2).join('\n');

  //     return { startTime, endTime, text };
  //   });
  // }

  function parseTime(timeString) {
    if (typeof timeString !== 'string') {
      return 0;
    }
    const parts = timeString.split(':');
    const secondsParts = parts[2].split(',');
    const hours = parseInt(parts[0], 10);
    const minutes = parseInt(parts[1], 10);
    const seconds = parseInt(secondsParts[0], 10);
    const milliseconds = parseInt(secondsParts[1], 10);
    return hours * 3600 + minutes * 60 + seconds + milliseconds / 1000;
  }

  function generateTableView(subtitles) {
    const rows = subtitles.map(
      (subtitle) => `<tr>
    <td>${subtitle.startTimeString}</td>
    <td>${subtitle.endTimeString}</td>
    <td>${subtitle.text}</td>
  </tr>`,
    );
    const table = `<table class="table table-bordered table-striped">
    <thead>
      <tr>
        <th>Start Time</th>
        <th>End Time</th>
        <th>Subtitles</th>
      </tr>
    </thead>
    <tbody>
      ${rows.join('')}
    </tbody>
  </table>`;
    return table;
  }

  function generateProseView(subtitles) {
    const paragraphs = subtitles.map((subtitle) => subtitle.text);
    const prose = paragraphs.join('');
    return prose;
  }

  function generateTranscript(subtitles) {
    const lines = subtitles.map((subtitle) => `<p>${subtitle.text}</p>`);
    return lines.join('');
  }

  function parseSrt(srt) {
    const subtitleBlocks = srt.trim().split(/\n\s*\n/);
    const subtitles = subtitleBlocks.map((subtitleBlock) => {
      let [timeString, ...textLines] = subtitleBlock.split('\n');
      timeString = textLines[0];
      textLines.shift(); // remove index
      // const [startTimeString, endTimeString] = timeString.split(' --> ');

      const times = timeString.split(' --> ');
      const startTime = parseTime(times[0]);
      const endTime = parseTime(times[1]);

      const text = textLines
        .join('\n')
        .replace(/<[^>]*>/g, '')
        .replace(/\{.*?\}/g, '');

      return {
        startTime,
        endTime,
        text,
      };
    });
    return subtitles;
  }

  function fetchSRT() {
    fetch('/sample_audio_orig.srt')
      .then((response) => response.text())
      .then((data) => {
        const subtitles = parseSrt(data); // Implement parseSRT function
        setSubs(subtitles);
      })
      .catch((error) => console.error('Error fetching subtitle file:', error));
  }

  useEffect(() => {
    fetchSRT();
  }, []);

  useEffect(() => {
    if (subs && subs.length > 0) {
      if (audioRef?.current) {
        audioRef?.current.addEventListener('timeupdate', (e) => {
          const currentTime = audioRef?.current.currentTime;
          setCurrentTime(currentTime);

          // const currentSubtitle = subs.find(
          //   (subtitle) =>
          //     currentTime >= subtitle.startTime &&
          //     currentTime <= subtitle.endTime,
          // );
        });
      }
    }
  }, [subs]);

  console.log(JSON.parse(test?.[0]?.speaker));
  return (
    <>
      <audio id="audio" controls ref={audioRef}>
        <source src="/sample_audio_orig.mp3" type="audio/mpeg" />
        Your browser does not support the audio tag.
      </audio>
      <div id="subtitle" className="text--danger"></div>

      {/* {subs?.length > 0
        ? subs?.map((s) => {
            const currentAudioTime = currentTime;
            const isCurrentSubtitle =
              currentAudioTime >= s.startTime && currentAudioTime <= s.endTime;
            // const currentSubtitle = subs.find(
            //   (subtitle) =>
            //     currentTime >= subtitle.startTime &&
            //     currentTime <= subtitle.endTime,
            // );
            return (
              <div
                className={`${
                  isCurrentSubtitle ? 'text--danger' : 'text--primary'
                }`}
              >
                {s.text}
              </div>
            );
          })
        : null} */}

      {test?.[0]?.speaker?.length > 0
        ? JSON.parse(test?.[0]?.speaker)?.map((s) => {
            const currentAudioTime = currentTime;
            const isCurrentSubtitle =
              currentAudioTime >=
                parseTime(
                  typeof s.start_time === Number
                    ? '00:00:00'
                    : s.start_time || '00:00:00',
                ) && currentAudioTime <= parseTime(s.end_time || '00:00:00');

            return (
              <div
                className={`${
                  isCurrentSubtitle ? 'text--danger' : 'text--primary'
                }`}
              >
                {s.speaker}&nbsp;:&nbsp;{s.text}
              </div>
            );
          })
        : null}
    </>
  );
};

export default CallsSummary;
